export default __webpack_public_path__ + "static/media/burglary-outlined.776d70de.svg";